import {
  fetchWithCache,
  getCachedData,
  clearCache,
} from "../services/apiService";

export const allProperties = async (
  { setProperties },
  forceRefresh = false
) => {
  // Clear cache if forcing refresh
  if (forceRefresh) {
    clearCache("/api/property/propertyList");
  }

  // Always show cached data immediately if available
  const cached = getCachedData("/api/property/propertyList", {});
  if (cached) {
    setProperties(cached);
  }

  // Fetch fresh data in background and update if changed
  try {
    const data = await fetchWithCache(
      "/api/property/propertyList",
      {
        method: "GET",
        retries: 2,
        timeout: 10000,
      },
      true // use cache fallback
    );
    // Only update if data is different from cache
    if (JSON.stringify(data) !== JSON.stringify(cached)) {
      setProperties(Array.isArray(data) ? data : []);
    }
  } catch (error) {
if (forceRefresh) {
      setProperties([]);
    }
  }
};
